import { render, staticRenderFns } from "./CampaignsTable.vue?vue&type=template&id=0aeb0d1b&scoped=true&"
import script from "./CampaignsTable.vue?vue&type=script&lang=js&"
export * from "./CampaignsTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsTable.vue?vue&type=style&index=0&id=0aeb0d1b&prod&lang=scss&scoped=true&"
import style1 from "./CampaignsTable.vue?vue&type=style&index=1&id=0aeb0d1b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeb0d1b",
  null
  
)

export default component.exports